module.exports = {
          srcSet: __webpack_public_path__ + "c16478e75bcf75defdd6c50faa5d444e-500.png"+" 500w",
          images:[ {path: __webpack_public_path__ + "c16478e75bcf75defdd6c50faa5d444e-500.png",width: 500,height: 216}],
          src: __webpack_public_path__ + "c16478e75bcf75defdd6c50faa5d444e-500.png",
          toString:function(){return __webpack_public_path__ + "c16478e75bcf75defdd6c50faa5d444e-500.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAECAYAAAC3OK7NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAdElEQVR4nD2MIQoCUQBEFxZhi0Wc8JoP7cp2cavVKJg2qMkgBrvgIbyNJ5Ovi2GGGd4wlWQseUg6SSUZSeoh/1XsKnlL9pKlZCLZyrSwRjKXfMtLcp+RSJ6Sg+QmuUj6wiS7MjxLjv6GJ8lashreN5JWsvgAsC0WJQpwIFAAAAAASUVORK5CYII=",
          width: 500,
          height: 216
        }